import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import { gameTypes } from 'config/promoGameTypes';

import ButtonViewMore from 'ugc/components/ugcGallery/montage/ButtonViewMore';
import Marquee from 'ugc/components/ugcGallery/marquee/Marquee';

export default function MarqueeContainer({
    config,
    clientBodyRef,
    data,
    buttonLink,
    needHandleClick = false,
    handleClick = () => {},
    isInit = true
}) {
    const { isShowButton } = config.buttonSettings;
    const { type } = useSelector(s => s.promo);
    const igGame = type === gameTypes.INSTAGRAM;
    const isShowPlayIcon = type === gameTypes.VIDEO_UPLOAD;

    return (
        <>
            <div ref={clientBodyRef} css={containerStyle(isInit)}>
                <Marquee
                    mediaData={data}
                    needHandleClick={needHandleClick}
                    handleClick={handleClick}
                    igGame={igGame}
                    isShowPlayIcon={isShowPlayIcon}
                />
                {isShowButton && (
                    <div css={buttonContainerStyle()}>
                        <a href={buttonLink} target="_blank" rel="noreferrer">
                            <ButtonViewMore config={config.buttonSettings} />
                        </a>
                    </div>
                )}
            </div>
        </>
    );
}

const containerStyle = isInit => css`
    padding: 16px 0 0 0;
    overflow: hidden;
    position: relative;
    min-height: 400px;
    max-height: 880px;
    ${!isInit && `opacity:0;`}
`;

const buttonContainerStyle = () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 168px;
    height: 100%;
    z-index: 2;
    margin: 16px;
`;
